// eslint-disable-next-line import/prefer-default-export
export const cardTestIds = {
  with_campaign_cheapest_price: 'with_campaign_cheapest_price',
  no_campaign_cheapest_price: 'no_campaign_cheapest_price',
  with_campaign_discount_amount: 'with_campaign_discount_amount',
  campaign_img: 'campaign_img',
};
